/**
 * ElecBid — Jobber OAuth Callback Handler
 * Sends the code to /api/jobber-auth which saves tokens server-side.
 * No Supabase client needed here — server uses service role key.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function JobberCallback({ onDone }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState("exchanging");
  const [error,  setError]  = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code   = params.get("code");
    // Jobber echoes back the signed `state` we set on connect — forward it as-is
    // so the server can verify it and recover the company.
    const state  = params.get("state") || "";
    if (!code) { setError("No authorization code in URL"); setStatus("error"); return; }

    // POST code to server — server does token exchange + Supabase save with service role key
    fetch("/api/jobber-auth?code=" + encodeURIComponent(code) + "&state=" + encodeURIComponent(state))
      .then(r => r.json())
      .then(data => {
        if (!data.ok && data.error) throw new Error(data.error);
        setStatus("done");
        setTimeout(() => {
          if (onDone) { window.history.replaceState({}, "", "/"); onDone(); }
          else { navigate("/"); }
        }, 1500);
      })
      .catch(err => { setError(err.message); setStatus("error"); });
  }, []);

  const center = {
    minHeight: "100vh", background: "#0d0f12", color: "#f0f0f0",
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", fontFamily: "'IBM Plex Sans', sans-serif",
    gap: 16, textAlign: "center", padding: 32,
  };

  return (
    <div style={center}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      {status === "exchanging" && <>
        <div style={{ width:40, height:40, borderRadius:"50%", border:"3px solid rgba(245,158,11,0.2)", borderTopColor:"#f59e0b", animation:"spin 0.8s linear infinite" }} />
        <div style={{ fontSize:18, fontWeight:700 }}>Connecting to Jobber...</div>
        <div style={{ color:"#8a919c" }}>Saving connection securely</div>
      </>}

      {status === "done" && <>
        <div style={{ width:64, height:64, borderRadius:"50%", background:"rgba(16,185,129,0.15)", border:"2px solid #10b981", color:"#10b981", fontSize:28, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" }}>✓</div>
        <div style={{ fontSize:20, fontWeight:700 }}>Jobber Connected!</div>
        <div style={{ color:"#8a919c" }}>ElecBid is now linked to Browning Electric</div>
      </>}

      {status === "error" && <>
        <div style={{ width:64, height:64, borderRadius:"50%", background:"rgba(239,68,68,0.12)", border:"2px solid #ef4444", color:"#ef4444", fontSize:28, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" }}>!</div>
        <div style={{ fontSize:20, fontWeight:700 }}>Connection Failed</div>
        <div style={{ color:"#8a919c", fontSize:13 }}>{error}</div>
        <button onClick={() => window.location.href="/api/jobber-auth?action=connect"}
          style={{ marginTop:16, padding:"12px 24px", background:"#f59e0b", color:"#0d0f12", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", fontSize:14 }}>
          Try Again
        </button>
      </>}
    </div>
  );
}
